import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import heroImage from "../assets/freepik__img1-contemporary-luxury-glass-villa-with-pool-and__89682.jpeg";
import pillarPrecisionImage from "../assets/united-arab-emirates-alif-mobility-pavilion-dubai-expo-2020.jpg";
import pillarDesignImage from "../assets/123331.jpg";
import pillarExcellenceImage from "../assets/ai-generated-house-design.jpg";
import launchesImage from "../assets/side-view-business-building-with-cloudy-sky-background.jpg";
import testimonialPriya from "../assets/27487.jpg";
import testimonialRajesh from "../assets/18155.jpg";
import testimonialVikram from "../assets/373318.jpg";
import quoteIcon from "../assets/quote-svgrepo-com.png";
import blogCardImage1 from "../assets/hand-adding-coins-stack-covered-dirt-plants.jpg";
import blogCardImage2 from "../assets/65203.jpg";
import blogCardImage3 from "../assets/construction-concept-engineering-tools.jpg";
import blogCardImage4 from "../assets/2148301697.jpg";
import leaf from "../assets/31984798_217_leaf.jpg";
import AboutSection from "./AboutSection";
import yogaImage from "../assets/yoga.png";
import gymImage from "../assets/gym.png";
import swimmingImage from "../assets/swim.png";
import parkingImage from "../assets/parking.png";

gsap.registerPlugin(ScrollTrigger);
const HeroSection = () => (
  <section className="hero">
    <div className="hero-media">
      <img src={heroImage} alt="Luxury villa exterior" />
    </div>
    <div className="hero-overlay">
      <div className="container hero-content">
        <h1 className="hero-title">
          <span>Foundation</span>
          <span style={{display: 'flex', justifyContent: 'center'}}> of Trust</span>
        </h1>
        <div className="hero-cta">
          <a href="#about" className="btn-primary" style={{color:'black'}}>
            Discover
          </a>
        </div>
      </div>
    </div>
  </section>
);

<AboutSection />

const PillarsSection = () => (
  <section className="pillars">


  <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <div className="pillars-divider" />
      <h2 className="pillars-title">
        The <span>foundation</span> behind every <span>development</span>
      </h2>
     <div className="pillars-divider" />
  </div>
  <div className="container">
    <div className="pillars-grid">
      <article className="pillar-card">
        <div className="pillar-media">
          <img src={pillarPrecisionImage} alt="" />
        </div>
        <div className="pillar-body">
          <h3>
            Built with <em>Precision</em>
          </h3>
          <p>
            At Dhanvanti Luxury Builders, Every project is driven by meticulous planning and attention to detail – from structural strength to refined finishes, combining durability, craftsmanship, and long-term value.
          </p>
        </div>
      </article>

      <article className="pillar-card featured">
        <div className="pillar-media" style={{marginTop: '50px'}}>
          <img src={pillarDesignImage} alt="" />
        </div>
        <div className="pillar-body">
          <h3>
            Designed <em>for Living</em>
          </h3>
          <p>
            We believe great design enhances everyday life. Our developments balance elegance with functionality, offering thoughtful layouts, natural light, and modern comforts that create spaces people truly connect with.
          </p>
        </div>
      </article>

      <article className="pillar-card">
        <div className="pillar-media">
          <img src={pillarExcellenceImage} alt="" />
        </div>
        <div className="pillar-body">
          <h3>
            Designed by <em>Excellence</em>
          </h3>
          <p>
            Excellence guides every stage of our work, from planning to delivery, ensuring that each development reflects trust, reliability, and lasting quality.
          </p>
        </div>
      </article>
    </div>
  </div>
</section>
);

const LaunchesSection = () => (
  <section id="projects" className="launches">

    {/* Top Divider */}
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <div className="launches-divider" />

      <h2 className="launches-title">
        Explore our <span>new launches</span>
      </h2>

    <div className="launches-divider" />
    </div>

    {/* Full Width Image */}
    <div className="launches-hero">
      <img src={launchesImage} alt="Modern residential building" />
    </div>

    {/* Bottom Amenities Panel */}
    <div className="launches-bottom">
      <div className="container launches-bottom-inner">

        <div className="launches-brand">
          <img src={leaf} alt="Leaf" style={{width: '100px', height: '100px'}}/>
        </div>

        <div className="launches-separator" />

        <div className="launches-amenities">
          <div className="amenity">
            <div>
              <img src={yogaImage} alt="Yoga Zone" />
            </div>
            <div class="amenity_text">
              <span>YOGA ZONE &</span>
              <strong>MEDITATION DECK</strong>
            </div>
          </div>

          <div className="amenity">
            <div>
              <img src={gymImage} alt="Gym Area" />
            </div>
            <div class="amenity_text">
              <span>GYM AREA &</span>
              <strong>FITNESS ARENA</strong>
            </div>
          </div>

          <div className="amenity">
            <div>
              <img src={swimmingImage} alt="Yoga Zone" />
            </div>
            <div class="amenity_text">
              <span>SWIMMING</span>
              <strong>ZONE</strong>
            </div>
          </div>

          <div className="amenity">
            <div>
              <img src={parkingImage} alt="Gym Area" />
            </div>
            <div class="amenity_text">
              <span>PRIVATE</span>
              <strong>PARKING</strong>
            </div>
          </div>
        </div>
      </div>

      <div className="launches-cta">
        <Link to="/projects" className="btn-outline discover-btn">
          Discover More <span className="arrow">→</span>
        </Link>
      </div>
    </div>
  </section>
);

const TestimonialsSection = () => (
  <section className="testimonials section" id="leadership">
    <div className="container">
      <div className="testimonials-grid">
      <h2 className="section-title">
        Here is what <span>clients say</span>
      </h2>
        <article className="testimonial-card">
          <div className="testimonial-media">
            <img src={testimonialPriya} alt="Priya Sharma" />
            <div className="testimonial-quote">
              <img src={quoteIcon} alt="" aria-hidden="true" />
            </div>
          </div>
          <div className="testimonial-body">
            <h3 className="testimonial-name">Priya Sharma</h3>
            <p>
              “A truly professional team that understands luxury real estate.
              Our investment with them has been worthwhile.”
            </p>
          </div>
        </article>
        <article className="testimonial-card">
          <div className="testimonial-media">
            <img src={testimonialRajesh} alt="Rajesh Kumar" />
            <div className="testimonial-quote">
              <img src={quoteIcon} alt="" aria-hidden="true" />
            </div>
          </div>
          <div className="testimonial-body">
            <h3 className="testimonial-name">Rajesh Kumar</h3>
            <p>
              “Dhanvanti Luxury Builders exceeded all our expectations. The
              quality of construction and attention to detail is outstanding.”
            </p>
          </div>
        </article>
        <article className="testimonial-card">
          <div className="testimonial-media">
            <img src={testimonialVikram} alt="Vikram Singh" />
            <div className="testimonial-quote">
              <img src={quoteIcon} alt="" aria-hidden="true" />
            </div>
          </div>
          <div className="testimonial-body">
            <h3 className="testimonial-name">Vikram Singh</h3>
            <p>
              “From design to completion, everything was handled with the utmost
              care and professionalism.”
            </p>
          </div>
        </article>
      </div>
    </div>
  </section>
);

const BlogSection = () => {
  const blogs = [
    {
      title:
        "Key Factors to Consider Before Investing in a Residential Property",
      image: blogCardImage1,
    },
    {
      title:
        "Luxury Living Explained: What Truly Defines a Premium Home",
      image: blogCardImage2,
    },
    {
      title:
        "From Blueprint to Reality: Understanding the Home Construction Journey Right Away",
      image: blogCardImage3,
    },
    {
      title:
        "Why Location, Planning, and Quality Matter in Real Estate Investments",
      image: blogCardImage4,
    },
  ];

  return (
    <section id="blog" className="blog section">
      <div className="container blog-layout">
        
        {/* Left Side Title */}
        <div className="blog-heading">
          <h2>
            Discover our
          </h2>
          <span>latest blog</span>
        </div>

        {/* Right Side First Blog */}
        <article className="blog-item">
          <div className="blog-image">
            <img src={blogs[0].image} alt="Blog" />
          </div>
          <p className="blog-meta">24.OCT.2025 | BY ADMIN</p>
          <h3 className="blog-title">{blogs[0].title}</h3>
        </article>

        {/* Remaining Blogs */}
        {blogs.slice(1).map((item) => (
          <article key={item.title} className="blog-item">
            <div className="blog-image">
              <img src={item.image} alt="Blog" />
            </div>
            <p className="blog-meta">24.OCT.2025 | BY ADMIN</p>
            <h3 className="blog-title">{item.title}</h3>
          </article>
        ))}
      </div>

      <div className="blog-cta">
        <Link to="/blog" className="btn-outline discover-btn">
          Discover More <span className="arrow">→</span>
        </Link>
      </div>
    </section>
  );
};

function HomePage() {
  useEffect(() => {
    const about = document.querySelector(".about");
    // gsap.to(".hero-media img", {
    //   scale: 1.1,
    //   scrollTrigger: {
    //     trigger: ".hero",
    //     start: "top top",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    // });

    gsap.fromTo(
      about,
      {
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
        y: 80,
      },
      {
        borderTopLeftRadius: "80px",
        borderTopRightRadius: "80px",
        y: 0,
        ease: "power3.out",
        scrollTrigger: {
          trigger: about,
          start: "top bottom",
          end: "top center",
          scrub: true,
        },
      }
    );
  }, []);
  return (
    <main id="home">
      <HeroSection />
      <AboutSection />
      <PillarsSection />
      <LaunchesSection />
      <TestimonialsSection />
      <BlogSection />
    </main>
  );
}

export default HomePage;

